export class Beaufort {
    public static LEVEL3: number = 5.4;
    public static LEVEL4: number = 7.9;
    public static LEVEL5: number = 10.7;
}